import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import C3Chart from './C3Chart';
import 'c3/c3.css';

import './BarrasPaises.css';

export class BarrasPaises extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datos: props.datos,
      pais: props.pais,
      atributoSeleccionado: props.atributoSeleccionado
    };
    this.indicePais = null;
  }

  render() {
    const t = this.props.t;
    let descripcion = t(this.state.atributoSeleccionado);
    return (
      <div>
        <h1 style={{ width: '100%', textAlign: 'center' }}>{descripcion}</h1>
        <div id="chart-c3-barras-paises" />
      </div>
    );
  }

  renderChart(atrSel, paisSel, datos, t) {
    const paises = datos.paises.slice();
    paises.sort((a, b) => {
      let va = a[atrSel];
      let vb = b[atrSel];
      if (va.hasOwnProperty('nombre')) {
        va = va.valor;
        vb = vb.valor;
      }
      return va - vb;
    });
    this.indicePais = null;
    for (let i = 0; !this.indicePais && i < paises.length; ++i) {
      if (paises[i] === paisSel) {
        this.indicePais = i;
      }
    }
    let getColor = function(color, d) {
      // d will be 'id' when called for legends
      if (d.id) {
        if (this.indicePais) {
          if (d.id === 'y' && d.index === this.indicePais) {
            return '#faca15';
          }
        }
      }
      return color;
    }.bind(this);
    const nombres = paises.map((pais, i) => {
      return t(pais.seleccion);
    });
    const valores = paises.map((pais, i) => {
      let val = pais[atrSel];
      if (val.hasOwnProperty('nombre')) {
        val = val.valor;
      }
      return val;
    });
    const sumatoria = valores.reduce((pv, cv) => pv + cv, 0.0);
    const promedio = sumatoria / valores.length;
    let data = {
      x: 'x',
      columns: [['x', ...nombres], ['y', ...valores]],
      type: 'bar',
      colors: {
        y: '#1c7ca2'
      },
      color: getColor
    };

    const mountNode = document.getElementById('chart-c3-barras-paises');

    ReactDOM.render(
      <C3Chart
        size={{ height: 200 }}
        data={data}
        bar={{ width: { ratio: 0.7 } }}
        axis={{
          x: {
            type: 'category',
            tick: {
              rotate: 90,
              multiline: false
            },
            height: 80
          }
        }}
        legend={{ show: false }}
        grid={{
          y: {
            lines: [
              {
                value: promedio,
                text: t('Promedio') + ': ' + promedio.toFixed(2),
                class: 'promedio',
                position: 'start'
              }
            ]
          }
        }}
      />,
      mountNode
    );
  }

  componentDidMount() {
    const atrSel = this.state.atributoSeleccionado;
    const datos = this.state.datos;
    const paisSel = this.state.pais;
    const t = this.props.t;
    this.renderChart(atrSel, paisSel, datos, t);
  }

  componentDidUpdate(prevProps, prevState) {
    const atrSel = this.state.atributoSeleccionado;
    const datos = this.state.datos;
    const paisSel = this.state.pais;
    const t = this.props.t;
    this.renderChart(atrSel, paisSel, datos, t);
  }
  componentWillReceiveProps = nextProps => {
    this.setState({
      pais: nextProps.pais,
      datos: nextProps.datos,
      atributoSeleccionado: nextProps.atributoSeleccionado
    });
  };
}



// WEBPACK FOOTER //
// ./src/components/BarrasPaises.js